import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { SlotGameType1 } from "../SlotGameType1";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
export class BurningSeven extends SlotGameType1 {
	protected override panelFactory: IPanelFactory = new BurningSevenPanelFactory();
	protected override helpFactory: IHelpFactory = new BurningSevenHelpFactory();
	//SEND COLOR 
	protected override color: RewardColor =
		{
			color: "white",
			coloroutherStroke: "black",
			colorinnerStroke: "darkred",
		}

	protected override colorLineMarkers: MarkersInfoColors =
		{
			MarkerbackgroundColor: "linear-gradient(90deg, rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};



	//LED COLOR
	protected override ColorLed: string = "250,0,0\n";
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "BurningSeven");
		this.spinnableReelsParams.topBorderWidth = 21;
		this.spinnableReelsParams.bottomBorderWidth = 13;
	}
}

//Panel Colorized
class BurningSevenPanelFactory implements IPanelFactory {
	public CreateNewPanel(params: PanelParams): Panel {
		return new BurningSevenPanel(params);
	}
}

class BurningSevenPanel extends Panel {
	protected override ButtonBackground(): ButtonColors {
		let color: ButtonColors = {
			backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
		};
		return color;
	}
}

class BurningSevenHelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new BurningSevenHelp(params);
	}
}

class BurningSevenHelp extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};
		return color;
	}
}